/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateFeatureFlagDto } from '../models/CreateFeatureFlagDto';
import type { GetFeatureFlagDto } from '../models/GetFeatureFlagDto';
import type { UpdateFeatureFlagDto } from '../models/UpdateFeatureFlagDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FeatureFlagsService {

    /**
     * Get all feature flags for preload
     * @returns GetFeatureFlagDto OK
     * @throws ApiError
     */
    public static getAllFeatureFlags(): CancelablePromise<Array<GetFeatureFlagDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/AllFeatureFlags',
        });
    }

    /**
     * Get tenant feature flags and shared ones
     * @returns GetFeatureFlagDto OK
     * @throws ApiError
     */
    public static getTenantFeatureFlags(): CancelablePromise<Array<GetFeatureFlagDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/TenantFeatureFlags',
        });
    }

    /**
     * Get tenant feature flag by ID
     * @param id 
     * @returns GetFeatureFlagDto OK
     * @throws ApiError
     */
    public static getFeatureFlagById(
id: number,
): CancelablePromise<GetFeatureFlagDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/FeatureFlag/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update feature flag by ID
     * @param id 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static updateFeatureFlagById(
id: number,
requestBody: UpdateFeatureFlagDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/FeatureFlag/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete feature flag by ID
     * @param id 
     * @returns void 
     * @throws ApiError
     */
    public static deleteFeatureFlagById(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/FeatureFlag/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Create feature flag
     * @param requestBody 
     * @returns any Created
     * @throws ApiError
     */
    public static createFeatureFlag(
requestBody: CreateFeatureFlagDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/FeatureFlag',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
